import React from 'react';
import moment from 'moment';

const AssetTransferListPrintTemplate = React.forwardRef(({ data }, ref) => {
    if (!data) return null;

    return (
        <div ref={ref} className="print-template" style={{
            padding: '20px',
            color: '#333',
            fontFamily: 'Times New Roman, serif',
            fontSize: '14px',
            lineHeight: '1.6'
        }}>
            {/* Header / Quốc hiệu tiêu ngữ */}
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '30px' }}>
                <div style={{ textAlign: 'center', width: '40%' }}>
                    <div style={{ fontWeight: 'bold', fontSize: '13px' }}>BỆNH VIỆN TWQĐ 108</div>
                    <div style={{ fontSize: '12px' }}>SỐ: {data.batchCode || '...........'}</div>
                </div>
                <div style={{ textAlign: 'center', width: '50%' }}>
                    <div style={{ fontWeight: 'bold', fontSize: '14px' }}>CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM</div>
                    <div style={{ fontWeight: 'bold', fontSize: '14px' }}>Độc lập - Tự do - Hạnh phúc</div>
                    <div style={{ borderBottom: '1px solid #000', width: '60%', margin: '5px auto' }}></div>
                    <div style={{ fontStyle: 'italic', marginTop: '10px' }}>
                        Hà Nội, ngày {moment().format('DD')} tháng {moment().format('MM')} năm {moment().format('YYYY')}
                    </div>
                </div>
            </div>

            {/* Title */}
            <div style={{ textAlign: 'center', marginBottom: '30px' }}>
                <h2 style={{ fontWeight: 'bold', fontSize: '20px', textTransform: 'uppercase', marginBottom: '5px' }}>PHIẾU ĐIỀU CHUYỂN TÀI SẢN</h2>
                <div style={{ fontStyle: 'italic' }}>(Kiêm biên bản bàn giao tài sản)</div>
            </div>

            {/* General Info */}
            <div style={{ marginBottom: '20px' }}>
                {/* Lấy requestedBy thay vì createdBy theo chuẩn form của bạn */}
                <p><strong>Người lập phiếu:</strong> {data.requestedBy || '.................................'}</p>
                <p><strong>Lý do điều chuyển:</strong> {data.reason || data.notes || '.................................'}</p>
            </div>

            {/* Table */}
            <table style={{
                width: '100%',
                borderCollapse: 'collapse',
                marginBottom: '30px'
            }}>
                <thead>
                    <tr>
                        <th style={tableHeaderStyle}>STT</th>
                        <th style={tableHeaderStyle}>Mã tài sản</th>
                        <th style={tableHeaderStyle}>Tên tài sản</th>
                        <th style={tableHeaderStyle}>Ngày điều chuyển</th>
                        <th style={tableHeaderStyle}>Nơi đi</th>
                        <th style={tableHeaderStyle}>Nơi đến</th>
                    </tr>
                </thead>
                <tbody>
                    {/* Bỏ map() đi vì data lúc này là 1 Object, in ra 1 dòng duy nhất */}
                    <tr>
                        <td style={{ ...tableCellStyle, textAlign: 'center' }}>1</td>
                        <td style={{ ...tableCellStyle, textAlign: 'center' }}>{data.asset?.assetCode || '-'}</td>
                        <td style={{ ...tableCellStyle, textAlign: 'center' }}>{data.asset?.assetName || '-'}</td>
                        <td style={{ ...tableCellStyle, textAlign: 'center' }}>
                            {data.transferDate ? new Date(data.transferDate).toLocaleDateString('vi-VN') : ''}
                        </td>
                        <td style={{ ...tableCellStyle, textAlign: 'center' }}>{data.fromDepartment?.departmentName || '-'}</td>
                        <td style={{ ...tableCellStyle, textAlign: 'center' }}>{data.toDepartment?.departmentName || '-'}</td>
                    </tr>
                </tbody>
            </table>

            {/* Footer / Signatures */}
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '50px', textAlign: 'center' }}>
                <div style={{ width: '30%' }}>
                    <div style={{ fontWeight: 'bold' }}>BÊN GIAO</div>
                    <div style={{ fontStyle: 'italic', fontSize: '12px' }}>(Ký, ghi rõ họ tên)</div>
                    <div style={{ height: '80px' }}></div>
                    <div style={{ fontWeight: 'bold' }}>{data.requestedBy}</div>
                </div>
                <div style={{ width: '30%' }}>
                    <div style={{ fontWeight: 'bold' }}>BÊN NHẬN</div>
                    <div style={{ fontStyle: 'italic', fontSize: '12px' }}>(Ký, ghi rõ họ tên)</div>
                    <div style={{ height: '80px' }}></div>
                </div>
                <div style={{ width: '30%' }}>
                    <div style={{ fontWeight: 'bold' }}>LÃNH ĐẠO PHÊ DUYỆT</div>
                    <div style={{ fontStyle: 'italic', fontSize: '12px' }}>(Ký, ghi rõ họ tên)</div>
                    <div style={{ height: '80px' }}></div>
                </div>
            </div>

            {/* CSS inline for printing */}
            <style>
                {`
                @media print {
                    .print-template { padding: 0 !important; }
                    button { display: none !important; }
                }
                `}
            </style>
        </div>
    );
});

const tableHeaderStyle = {
    border: '1px solid #000',
    padding: '8px',
    backgroundColor: '#f2f2f2',
    fontWeight: 'bold',
    textAlign: 'center'
};

const tableCellStyle = {
    border: '1px solid #000',
    padding: '8px',
    verticalAlign: 'middle'
};

export default AssetTransferListPrintTemplate;